@if(isModernLayout) {
  @if (tableConfig?.title || tableConfig?.description || !topOptions?.inlineActions) {
  <div class="modern-table-heading mb-6 flex min-w-0 flex-wrap items-center justify-between gap-8">
    <div class="modern-table-heading-copy flex min-w-0 flex-1 flex-col gap-8">
      @if (tableConfig?.title; as title) {
        <h2 class="modern-table-title">{{ title | translate }}</h2>
      }
      @if (tableConfig?.description; as description) {
        <p class="modern-table-description">{{ description | translate }}</p>
      }
    </div>
    @if (!topOptions?.inlineActions) {
      <app-table-actions class="modern-table-actions" [actions]="modernTopActions" [selection]="selection" [layout]="TableLayout.MODERN" />
    }
  </div>
  }
}

<div [ngClass]="{ 'cardWithShadow': !tableConfig?.disableCardStyling, 'p-y-24': !parentTable && !tableConfig?.disableCardStyling }" class="table-wrapper">
  <app-top-table
    [currentSearchText]="currentSearchText"
    [keyword]="keyword"
    [filterTableConfig]="tableConfig?.filterTable" 
    [handleFilterTable]="handleFilterTable"/>
  @if (isModernLayout && selection.hasValue()) {
    <div class="modern-selection-toolbar">
      <span class="modern-selection-label">
        {{ (tableConfig?.selectionLabel ?? 'n selected') | translate: { count: selection.selected.length } }}
      </span>
      <div class="flex flex-wrap items-center gap-2">
        @for (action of selectionActions; track action.name) {
          @if (!action.hidden?.()) {
            <button
              type="button"
              class="modern-selection-action"
              [ngClass]="action.class ?? ''"
              [class.modern-selection-action-danger]="action.class?.includes('selection-action-danger')"
              [disabled]="action.disabled?.(selection) ?? false"
              (click)="action.action?.(selection)">
              @if (action.icon) {
                <i-tabler [name]="action.icon" class="size-3.5! shrink-0 [&>svg]:size-3.5!" />
              }
              <span>{{ (typeof action.name === 'function' ? action.name() : action.name) | translate }}</span>
            </button>
          }
        }
        <button type="button" class="modern-selection-clear" (click)="selection.clear()">
          {{ 'clear' | translate }}
        </button>
      </div>
    </div>
  }
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows (matSortChange)="onSortChange()" class="w-100" [class.modern-table]="isModernLayout"
      cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!isDraggable">
      <!-- DEFINE -->
      <!-- Define group header -->
      @for(groupColumn of displayedGroupColumns; track groupColumn) {
        <tr mat-header-row *matHeaderRowDef="groupColumn"></tr>
      }
      <!-- Define header -->
      @if(!tableConfig?.hideHeader) {
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      }
      <!-- Define filter header -->
      @if(hasFilter) {
        <tr mat-header-row *matHeaderRowDef="displayedFilterColumns"></tr>
      }
      <!-- Define body -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="position-relative hover-bg" [ngClass]="getRowStyle(row)" cdkDrag [cdkDragData]="row" (cdkDragStarted)="onDragStart()"></tr>
      @if (expandConfig) {
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-detail-row position-relative"></tr>
      }
      <!-- IMPLEMENT -->
      <!-- Implement group header -->
      @for(groupColumn of groupColumnConfig; track groupColumn) {
        @for(group of groupColumn; track group) {
          <ng-container [matColumnDef]="group.key">
            <th 
              mat-header-cell 
              *matHeaderCellDef 
              [id]="group.key + '-group-header'" 
              [attr.colspan]="group.titleSpan"
              [ngStyle]="group.style"
            >
              {{ group.title ? (group.title | translate) : "" }}
            </th>
          </ng-container>
        }
      }
      @for(column of tableConfig?.columnConfig; track column.key) {
      <ng-container [matColumnDef]="column.key" [stickyEnd]="isModernInlineActionColumn(column)">
        <!-- Implement header -->
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [id]="column.key + '-header'"
          [disabled]="!column.sortable"
          [attr.colspan]="column.titleSpan ? column.titleSpan : 1"
          [ngClass]="[
            getTitleAlign(column.titleAlign),
            isModernInlineActionColumn(column) ? 'w-[52px]! min-w-[52px]! max-w-[52px]! px-0!' : ''
          ]"
          [class.modern-sticky-action-cell]="isModernInlineActionColumn(column)"
          class="f-w-600 default-cell text-nowrap bg-th"
          [ngStyle]="column.titleStyle"
          (click)="column.onClickTitle?.(column)"
        >
          @switch (column.titleDataType) { 
            @case (columnType.DYNAMIC_COMPONENT) {
              <ng-template *ngComponentOutlet="getTitleValue(column)[0]; inputs: getTitleValue(column)[1]" />
            } @case (columnType.HTML) {
              <app-html-formatter [htmlText]="getTitleValue(column)"/>
            } @default {
              <div class="lh-sm">{{ getTitleValue(column) | translate }}</div>
            } 
          }
        </th>
        <!-- Implement filter header -->
        <ng-container [matColumnDef]="column.key.concat('-filter')">
          <th class="filter-header filter-header-border p-x-0" mat-header-cell *matHeaderCellDef>
            <app-filter-header #filterHeader [column]="column" [currentColumnFilterText]="currentColumnFilterText" [currentColumnFilterOperator]="currentColumnFilterOperator" (columnFilterEvent)="columnFilterEvent($event)"/>
          </th>
        </ng-container>
        <!-- Implement body -->
        <td
          mat-cell
          *matCellDef="let row;"
          (contextmenu)="onRightClickCell($event, { row, column })"
          (click)="onClickRowEvent(row, column)"
          [matTooltip]="column.tooltip ? getCellValue({ row, column }) : null"
          class="default-cell py-2!"
          [ngClass]="isModernInlineActionColumn(column) ? 'w-[52px]! min-w-[52px]! max-w-[52px]! px-0!' : ''"
          [class.modern-sticky-action-cell]="isModernInlineActionColumn(column)"
          [class.cursor-pointer]="column.onClickCell || onClickRow"
          [ngStyle]="getCellStyle({ row, column })"
        >
          @switch (getCellDataType({ row, column })) { 
            @case (columnType.DYNAMIC_COMPONENT) {
              <ng-template *ngComponentOutlet="getCellValue({ row, column })[0] inputs: getCellValue({ row, column })[1]" />
            } @case (columnType.HTML) {
              <app-html-formatter [htmlText]="column.cellValue?.({ row, column })" />
            } @default {
              {{ getCellValue({ row, column }) }}
            } 
          }
        </td>
      </ng-container>
      }
      <!-- Selection -->
      <!-- Placeholder for selection -->
      @if(hasFilter) {
        <ng-container [matColumnDef]="'col-selection-filter'">
          <th mat-header-cell *matHeaderCellDef class="filter-header-border"></th>
        </ng-container>
      }
      <!-- Implement selection in row -->
      <ng-container [matColumnDef]="'col-selection'">
        <!-- Select all -->
        <th mat-header-cell *matHeaderCellDef [ngStyle]="selectionOptions?.selectStyle?.(true)" class="bg-th selection-header-cell">
          <mat-checkbox
            id="master-select"
            [disabled]="selectionOptions?.disabled || dataSourceSelection.data.length < 1"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && IsAllSelected"
            [indeterminate]="selection.hasValue() && !IsAllSelected"
          />
        </th>
        <!-- Select row -->
        <td mat-cell *matCellDef="let row" [ngStyle]="selectionOptions?.selectStyle?.(true)" class="border-b-0!">
          <mat-checkbox
            (change)="rowToggle(row)"
            [disabled]="selectionOptions?.disabled"
            [checked]="selection.isSelected(row)"
          />
        </td>
      </ng-container>
      <!-- Expand -->
      <ng-container matColumnDef="expandedDetail">
        <td matcell *matCellDef="let row" [attr.colspan]="displayedColumns.length" [ngClass]="getExpandClass()" class="p-0">
          @if (expandConfig) {
            <div class="overflow-hidden" [@detailExpand]="expandStatus.get(row.id) ? expandConfig.expandAnimation : 'collapsed'">
              <!-- only render child if open -->
              <ng-template *ngComponentOutlet="expandConfig.component inputs: { row, isExpand: expandStatus.get(row.id), inputs: expandConfig.componentInput }" />
            </div>
          }
        </td>
      </ng-container>
    </table>
    @if (isLoading) {
      <div class="d-flex justify-content-center p-y-16">
        <mat-spinner [diameter]="40" />
      </div>
    }
  </div>
  @if (!tableConfig?.hidePaginator) {
    <mat-paginator
      class="position-relative paginator p-t-8"
      [pageSizeOptions]="pageSizeOption"
      [length]="totalRecord"
      [pageSize]="params.pageSize"
      [pageIndex]="params.page - 1"
      (page)="onPageChange($event)"
    />
  }
</div>
